import { render, staticRenderFns } from "./DashButton.vue?vue&type=template&id=444fbce4&scoped=true&"
import script from "./DashButton.vue?vue&type=script&lang=js&"
export * from "./DashButton.vue?vue&type=script&lang=js&"
import style0 from "./DashButton.vue?vue&type=style&index=0&id=444fbce4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444fbce4",
  null
  
)

export default component.exports